import React, { FC } from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';

interface Props {
  classes?: any;
  text?: string;
}

const PageNotFound: FC<Props> = (props: Props) => {
  const { classes, text } = props;
  return <div className={classes.container}>{text}</div>;
};

PageNotFound.defaultProps = {
  classes: {},
  text: '404 : Page Not Found',
};

export default injectSheet(styleSheet)(PageNotFound);
